import React from "react";
import { NavLink } from "react-router-dom";
import Notifications from "../MyComponents/NotificationsComponent";
import { Translate } from "../../helpers/Translate";
import { NavItem } from "reactstrap";
import { useSelector } from "react-redux";
import { ApplicationState } from "../../store/index";

function DashBoardNav(props: any) {
  let t = new Translate();
  const user = useSelector((state: ApplicationState) => state.user);

  // Check if user is NOT a student
  const isNotStudent = (user as any)?.userRole?.rolename !== "Student";

  const navBarStyle = {
    boxShadow: "0px 1px 20px 0px rgba(0, 0, 0, 1)",
  };

  return (
    <nav
      className="sb-topnav navbar navbar-expand-lg navbar-dark bg-dark"
      style={navBarStyle}
    >
      <div className="container-fluid d-flex justify-content-between align-items-center flex-wrap">
        <NavLink className="navbar-brand" to="/" style={{ fontSize: "1rem" }}>
          {t.translate("Assessments Platform ")}
        </NavLink>

        {isNotStudent && (
          <div className="d-flex flex-wrap gap-2 align-items-center">
            <NavLink
              to="/"
              className="btn btn-outline-light btn-sm"
              activeClassName="active"
              exact
              style={{ whiteSpace: "nowrap" }}
            >
              <i className="fa fa-home me-1"></i>
              <span className="d-none d-sm-inline">Home</span>
            </NavLink>
            <NavLink
              to="/PendingExams"
              className="btn btn-outline-light btn-sm"
              activeClassName="active"
              style={{ whiteSpace: "nowrap" }}
            >
              <i className="fa fa-tasks me-1"></i>
              <span className="d-none d-md-inline">
                View Pending Assignments
              </span>
              <span className="d-inline d-md-none">Assignments</span>
            </NavLink>
          </div>
        )}
      </div>

      {/* <button className="btn btn-link btn-sm order-1 order-lg-0" id="sidebarToggle" onClick={props.toggleSideBar}>
        <i className="fa fa-bars"></i>
      </button> */}

      {/* <form className="d-none d-md-inline-block form-inline ml-auto mr-0 mr-md-3 my-2 my-md-0">
      <div className="input-group">
        <input className="form-control" type="text" placeholder="Search for..." aria-label="Search"
          aria-describedby="basic-addon2" />
        <div className="input-group-append">
          <button className="btn btn-primary" type="button"><i className="fa fa-search"></i></button>
        </div>
      </div>
    </form><Notifications /> */}
      <ul className="navbar-nav d-none">
        <li className="nav-item dropdown"></li>
      </ul>
    </nav>
  );
}

export default DashBoardNav;
